// eslint-disable-next-line
import { types, NAME } from './reducer'
const lang = document.documentElement.lang.slice(0, 2);

export const actions = {
  getSubscription: () => ({
    //
  }),
  startPreExersize: () => (dispatch, getState) => {
    let state = getState().SCHULTELETTERS
    let newCurrentLvl = localStorage.getItem(state.schulteType.exersizeName + "CURRENT_LVL")
    if (newCurrentLvl) {
      state.currentLvl = newCurrentLvl
    }
    dispatch(actions.generateNewLettersMatrix())
    dispatch({
      type: "PREEXERSIZE",
      currentLvl: state.currentLvl
    })
  },
  highlightElement: () => ({
    type: "HIGHLIGHT"
  }),
  incrementCountDown: () => ({
    type: "INCREMENT_COUNTDOWN"
  }),
  increment: () => ({
    type: "INCREMENT"
  }),
  setIncrementCountDown: (newCountDown) => ({
    type: "SET_INCREMENT_COUNT_DOWN",
    newCountDown
  }),
  startGame: (newCountDown) => (dispatch, getState) => {
    dispatch(actions.setAutoHelp())
    dispatch({
      type: "START_GAME",
      newCountDown
    })
  },
  showAutoHelp: () => (dispatch, getState) => {
    let state = getState().SCHULTELETTERS
    for( let i =0;i<state.lettersMatrix.length;i++) {
      for(let j = 0; j<state.lettersMatrix[i].length;j++) {
        if(state.lettersMatrix[i][j].value === state.toFindMatrix[state.toFindPosition]) {
          state.lettersMatrix[i][j].animation = 'textBlink'
        }
      }
    }
    dispatch({
      type: "SHOW_AUTO_HELP"
    })
  },
  setAutoHelp: (newLeftToFind) => (dispatch, getState) => {
    let state = getState().SCHULTELETTERS
    if(state.autoHelp.timer) {
      clearTimeout(state.autoHelp.timer)
    }
    let timeOut = 15000
    let leftToFind = newLeftToFind? newLeftToFind : 10
    if(leftToFind <= state.autoHelp.remainingForAutoHelp) {
      timeOut = 5000
    }
    state.autoHelp.timer = setTimeout( () => {
      dispatch(actions.showAutoHelp())
    },timeOut)
    dispatch({
      type: "SET_AUTO_HELP"
    })
  },
  gameOverAction: () => (dispatch, getState) => {
    let state = getState().SCHULTELETTERS
    //----------------------------------------------------Global lvl controller----------------------
    let currentLvl = localStorage.getItem(state.schulteType.exersizeName + "CURRENT_LVL")
    let exersizesToUpdate = localStorage.getItem(state.schulteType.exersizeName + "LEFT_TO_UP")
    let exersizesToDowngrade = localStorage.getItem(state.schulteType.exersizeName + "LEFT_TO_DOWN")
    function lvlController(n, currentLvlName) {
      let roundNames = ['START', 'SMALL', 'MEDIUM', 'BIG']
      for (let i = 0; i < roundNames.length; i++) {
        if (roundNames[i] === currentLvlName) {
          return roundNames[i + n]
        }
      }
    }
    function setGlobalLvl(newLvl) {
      exersizesToUpdate = state.lvlInfo[newLvl].defaultLeftToUp
      exersizesToDowngrade = state.lvlInfo[newLvl].defaultLeftToDown
      localStorage.setItem(state.schulteType.exersizeName + "CURRENT_LVL", newLvl)
      localStorage.setItem(state.schulteType.exersizeName + "LEFT_TO_UP", exersizesToUpdate)
      localStorage.setItem(state.schulteType.exersizeName + "LEFT_TO_DOWN", exersizesToDowngrade)
    }
    if (!currentLvl) {
      setGlobalLvl("START")
      currentLvl = "START"
    }
    if (!exersizesToUpdate) {
      exersizesToUpdate = state.lvlInfo[currentLvl].defaultLeftToUp
    }
    if (!exersizesToDowngrade) {
      exersizesToDowngrade = state.lvlInfo[currentLvl].defaultLeftToDown
    }
    if (state.lastLvlUpdate === "UPGRADE") {
      localStorage.removeItem(state.schulteType.exersizeName + "LEFT_TO_DOWN")
      exersizesToUpdate--
      localStorage.setItem(state.schulteType.exersizeName + "LEFT_TO_UP", exersizesToUpdate)
      if (exersizesToUpdate <= 0) {
        setGlobalLvl(lvlController(+1, currentLvl))
      }
    } else if (state.lastLvlUpdate === "DOWNGRADE" || state.currentRound <= state.lvlInfo[currentLvl].leftToUp) {
      localStorage.removeItem(state.schulteType.exersizeName + "LEFT_TO_UP")
      exersizesToDowngrade--
      localStorage.setItem(state.schulteType.exersizeName + "LEFT_TO_DOWN", exersizesToDowngrade)
      if (exersizesToDowngrade <= 0) {
        setGlobalLvl(lvlController(-1, currentLvl))
      }
    }
    //--------------------------------------------------------------------------------------------------------------------------
    dispatch({
      type: "GAME_OVER"
    })
  },
  generateNewLettersMatrix: () => (dispatch, getState) => {
    let state = getState().SCHULTELETTERS
    let size = state.lvlInfo[state.currentLvl].size
    function getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    let newMatrix = [];
    let totalSize = size * size;
    let alphabet = state.schulteType.getMatix(totalSize)
    for (let i = 0; alphabet.length < totalSize; i++) {
      alphabet.push(alphabet[i])
    }
    let alphabetSorted = [...alphabet];
    for (let i = 0; i < alphabet.length; i++) {
      let firstIndex = getRandomInt(0, alphabet.length - 1)
      let secondIndex = getRandomInt(0, alphabet.length - 1)
      let temp = alphabet[firstIndex]
      alphabet[firstIndex] = alphabet[secondIndex]
      alphabet[secondIndex] = temp
    }
    let k = 0;
    for (let i = 0; i < size; i++) {
      let secondaryArray = []
      for (let j = 0; j < size; j++, k++) {
        let cell = {
          value: alphabet[k]
        }
        if(lang === 'ru') {
          if(cell.value === 3) {
            cell.advancedValue = 'З'
          } else if(cell.value === 'З') {
            cell.advancedValue = 3
          }
        }
        secondaryArray.push(cell)
      }
      newMatrix.push(secondaryArray)
    }
    dispatch({
      type: "GENERATE_MATRIX",
      toFindMatrix: alphabetSorted,
      lettersMatrix: newMatrix,
    })
  },
  showGameOverScreanAction: () => ({
    type: "SHOW_GAME_OVER_SCREAN"
  }),
  cellClickAction: (rowIndex, columnIndex, cell) => (dispatch, getState) => {
    let state = getState().SCHULTELETTERS
    let newMatrix = state.lettersMatrix
    let newPoints = state.points;
    let newToFindPosition = state.toFindPosition
    let newWrongAnswers = state.wrongAnswers
    let newTimeLeft = state.timeLeft
    let newStep = state.exersizeState;
    let fullSize = state.lvlInfo[state.currentLvl].size * state.lvlInfo[state.currentLvl].size

    if (cell.value === state.toFindMatrix[state.toFindPosition] || (cell.advancedValue && cell.advancedValue === state.toFindMatrix[state.toFindPosition])) {
      //---------------------------------------------------------------For correct animation of one Letter
      if (newMatrix[rowIndex][columnIndex].animation === 'whiteGreeanWhiteAnimation') {
        newMatrix[rowIndex][columnIndex].animation = 'whiteGreeanWhiteAnimationSecond'
      } else {
        newMatrix[rowIndex][columnIndex].animation = 'whiteGreeanWhiteAnimation'
      }
      //-----------------------------------------------------------------------------------------------------------------
      newToFindPosition++;
      newPoints += state.lvlInfo[state.currentLvl].pointsPerClick
      if (state.toFindMatrix.length - 1 <= state.toFindPosition) {
        dispatch(actions.newRound())
        let state = getState().SCHULTELETTERS
        newMatrix = state.lettersMatrix
        newToFindPosition = 0
      }
    } else {
      //---------------------------------------------------------------For correct animation of one Letter
      if (newMatrix[rowIndex][columnIndex].animation === 'redAnimation') {
        newMatrix[rowIndex][columnIndex].animation = 'redAnimationSecond'
      } else {
        newMatrix[rowIndex][columnIndex].animation = 'redAnimation'
      }
      //-----------------------------------------------------------------------------------------------------------------
      newWrongAnswers++
      //-----------------------------------Local LVL Controller---
      state.lvlInfo[state.currentLvl].clickToFail--;
      //----------------------------------------------------------------------
      if (newTimeLeft > 5) {
        newTimeLeft -= 5
      } else {
        newStep = 'gameOver';
        newTimeLeft = -1;
      }
    }
    //---------------------------------------------------------
    dispatch(actions.setAutoHelp(fullSize - state.toFindPosition-1))
    //----------------------------------------------------------------------------------------------
    dispatch({
      type: "CELL_CLICK",
      toFindPosition: newToFindPosition,
      lettersMatrix: newMatrix,
      points: newPoints,
      wrongAnswers: newWrongAnswers,
      timeLeft: newTimeLeft,
      exersizeState: newStep,
      lvlInfo: state.lvlInfo,
      autoHelp: state.autoHelp
    })
  },
  setType: (schulteType,lvlInfo) => ({
    type: "SET_SCHULTE_TYPE",
    schulteType: schulteType,
    lvlInfo: lvlInfo
  }),
  newRound: () => (dispatch, getState) => {
    let state = getState().SCHULTELETTERS
    //------------------------------------Local LVL Controller------------------------------------------
    function lvlController(n) {
      let roundNames = ['START', 'SMALL', 'MEDIUM', 'BIG']
      //--------------------restore default values for lvlController
      state.lvlInfo[state.currentLvl].leftToUp = state.lvlInfo[state.currentLvl].defaultLeftToUp
      state.lvlInfo[state.currentLvl].clickToFail = state.lvlInfo[state.currentLvl].defaultClickToFail
      state.lvlInfo[state.currentLvl].leftToDown = state.lvlInfo[state.currentLvl].defaultLeftToDown
      //--------------------------------------------------------------------------
      for (let i = 0; i < roundNames.length; i++) {
        if (roundNames[i] === state.currentLvl) {
          return roundNames[i + n]
        }
      }
    }
    if (state.lvlInfo[state.currentLvl].clickToFail <= 0) {
      state.lvlInfo[state.currentLvl].leftToDown--
      if (state.lvlInfo[state.currentLvl].leftToDown <= 0) {
        state.lastLvlUpdate = "DOWNGRADE"
        state.currentLvl = lvlController(-1)
      }
    } else {
      state.lvlInfo[state.currentLvl].leftToUp--
      if (state.lvlInfo[state.currentLvl].leftToUp <= 0) {
        state.lastLvlUpdate = "UPGRADE"
        state.currentLvl = lvlController(+1)
      }
    }
    //-------------------------------------------------------------------------------------------------------------------
    dispatch(actions.generateNewLettersMatrix())  
    dispatch(actions.setAutoHelp())
    dispatch({
      type: "NEW_ROUND",
      lvlInfo: state.lvlInfo,
      currentLvl: state.currentLvl,
      currentRound: state.currentRound + 1,
      lastLvlUpdate: state.lastLvlUpdate
    })
  }
}
